import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";

/*component*/
import Header from "./Component/Header";
import HomeHeader from "./Component/HomeHeader.js";
/*pages */
import Home from "./Page/Home";
/*Hat*/
import HatIntroduce from "./Page/HatBusiness/Introduce.js";
import KoreaCompany from "./Page/HatBusiness/KoreaCompany.js";
import ProductionCorporation from "./Page/HatBusiness/ProductionCorporation.js";
import ProductionCorporation2 from "./Page/HatBusiness/ProductionCorporation2.js";
import ProductionCorporation3 from "./Page/HatBusiness/ProductionCorporation3.js";
import ProductionCorporation4 from "./Page/HatBusiness/ProductionCorporation4.js";
import SalesCorporation from "./Page/HatBusiness/SalesCorporation.js";
import SalesCorporation2 from "./Page/HatBusiness/SalesCorporation2.js";
import SalesCorporation3 from "./Page/HatBusiness/SalesCorporation3.js";
import History from "./Page/HatBusiness/History.js";
/*fork */
import ForkIntroduce from "./Page/ForkBusiness/introduce.js";
import ForkHeadOfficeUsa from "./Page/ForkBusiness/ForkHeadOfficeUsa.js";
import ForkHeadOffice2 from "./Page/ForkBusiness/ForkHeadOffice2.js";
import ForkHeadOffice3 from "./Page/ForkBusiness/ForkHeadOffice3.js";
import ForkHeadOffice4 from "./Page/ForkBusiness/ForkHeadOffice4.js";
import ForkHeadOffice5 from "./Page/ForkBusiness/ForkHeadOffice5.js";
import ForkHeadOffice6 from "./Page/ForkBusiness/ForkHeadOffice6.js";
import ForkHeadOffice7 from "./Page/ForkBusiness/ForkHeadOffice7.js";
import ForkHeadOffice8 from "./Page/ForkBusiness/ForkHeadOffice8.js";
import ForkHeadOffice9 from "./Page/ForkBusiness/ForkHeadOffice9.js";
import ForkHeadOffice10 from "./Page/ForkBusiness/ForkHeadOffice10.js";
import ForkHeadOffice11 from "./Page/ForkBusiness/ForkHeadOffice11.js";
import ForkHeadOffice12 from "./Page/ForkBusiness/ForkHeadOffice12.js";
import Histroy from "./Page/ForkBusiness/History.js";
/*Car */
import CarIntroduce from "./Page/CarBusiness/Introduce.js";
import CarAsService from "./Page/CarBusiness/AsService.js";
import CarBusinessHistory from "./Page/CarBusiness/CarBusinessHistory.js";
import CarOverseasBus from "./Page/BusBusiness/OverseasBus.js";
import CarFactory from "./Page/BusBusiness/Factory.js";
import CarFactory2 from "./Page/BusBusiness/Factory2.js";
import CarFactory3 from "./Page/BusBusiness/Factory3.js";
import CarFactory4 from "./Page/BusBusiness/Factory4.js";
import CarFactory5 from "./Page/BusBusiness/Factory5.js";
import CarFactory6 from "./Page/BusBusiness/Factory6.js";
import BusBusinessHistory from "./Page/BusBusiness/BusBusinessHistory.js";
/*General */
import GeneralIntroduce from "./Page/GeneralBusiness/Introduce.js";
import GeneralHistory from "./Page/GeneralBusiness/History.js";
/*SocialService */
import SocialService from "./Page/SocialBusiness/SocialService.js";
import Scholarship from "./Page/SocialBusiness/Scholarship.js";
import EducationBusiness from "./Page/SocialBusiness/EducationBusiness.js";
import Obs from "./Page/SocialBusiness/Obs.js";
import Museum from "./Page/SocialBusiness/Museum.js";
/*WBH */
import Wbh from "./Page/SocialBusiness/Wbh.js";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HomeHeader />
              <Home />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/Introduce"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <HatIntroduce />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/KoreaCompany"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <KoreaCompany />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/ProductionCorporation"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <ProductionCorporation />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/ProductionCorporation2"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <ProductionCorporation2 />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/ProductionCorporation3"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <ProductionCorporation3 />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/ProductionCorporation4"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <ProductionCorporation4 />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/SalesCorporation"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <SalesCorporation />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/SalesCorporation2"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <SalesCorporation2 />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/SalesCorporation3"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <SalesCorporation3 />
            </>
          }
        ></Route>
        <Route
          path="/HatBusiness/History"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
              <History />
            </>
          }
        ></Route>

        <Route
          path="/ForkLiftBusiness/Introduce"
          element={
            <>
              <Header color={"var(--green)"} />
              <ForkIntroduce />
            </>
          }
        ></Route>

        <Route
          path="/ForkLiftBusiness/HeadOfficeUsa"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOfficeUsa />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice2"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice2 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice3"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice3 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice4"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice4 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice5"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice5 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice6"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice6 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice7"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice7 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice8"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice8 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice9"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice9 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice10"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice10 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice11"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice11 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/HeadOffice12"
          element={
            <>
              <Header color={"var(--green)"} /> <ForkHeadOffice12 />
            </>
          }
        ></Route>
        <Route
          path="/ForkLiftBusiness/History"
          element={
            <>
              <Header color={"var(--green)"} /> <Histroy />
            </>
          }
        ></Route>
        <Route
          path="/CarBusiness/Introduce"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarIntroduce />
            </>
          }
        ></Route>
        <Route
          path="/CarBusiness/AsService"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarAsService />
            </>
          }
        ></Route>
        <Route
          path="/CarBusiness/CarBusinessHistory"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarBusinessHistory />
            </>
          }
        ></Route>
        <Route
          path="/BusBusiness/OverseasBus"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarOverseasBus />
            </>
          }
        ></Route>

        <Route
          path="/BusBusiness/Factory"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarFactory />
            </>
          }
        ></Route>
        <Route
          path="/BusBusiness/Factory2"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarFactory2 />
            </>
          }
        ></Route>
        <Route
          path="/BusBusiness/Factory3"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarFactory3 />
            </>
          }
        ></Route>
        <Route
          path="/BusBusiness/Factory4"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarFactory4 />
            </>
          }
        ></Route>
        <Route
          path="/BusBusiness/Factory5"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarFactory5 />
            </>
          }
        ></Route>
        <Route
          path="/BusBusiness/Factory6"
          element={
            <>
              <Header color={"var(--navi)"} /> <CarFactory6 />
            </>
          }
        ></Route>

        <Route
          path="/BusBusiness/BusBusinessHistory"
          element={
            <>
              <Header color={"var(--navi)"} /> <BusBusinessHistory />
            </>
          }
        ></Route>

        <Route
          path="/GeneralBusiness/introduce"
          element={
            <>
              <Header color={"var(--purple)"} /> <GeneralIntroduce />
            </>
          }
        ></Route>

        <Route
          path="/GeneralBusiness/history"
          element={
            <>
              <Header color={"var(--purple)"} /> <GeneralHistory />
            </>
          }
        ></Route>

        <Route
          path="/SocialBusiness/SocialService"
          element={
            <>
              <Header color={"var(--pink)"} /> <SocialService />
            </>
          }
        ></Route>
        <Route
          path="/SocialBusiness/Scholarship"
          element={
            <>
              <Header color={"var(--pink)"} /> <Scholarship />
            </>
          }
        ></Route>
        <Route
          path="/SocialBusiness/EducationBusiness"
          element={
            <>
              <Header color={"var(--pink)"} /> <EducationBusiness />
            </>
          }
        ></Route>
        <Route
          path="/SocialBusiness/Obs"
          element={
            <>
              <Header color={"var(--pink)"} /> <Obs />
            </>
          }
        ></Route>
        <Route
          path="/SocialBusiness/Museum"
          element={
            <>
              <Header color={"var(--pink)"} /> <Museum />
            </>
          }
        ></Route>

        <Route
          path="/WBH/WBH"
          element={
            <>
              <Header color={"var(--pink)"} /> <Wbh />
            </>
          }
        ></Route>

        <Route
          path="*"
          element={
            <>
              <Header color={"var(--strong-brown)"} />
            </>
          }
        ></Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
